import React from "react";

const CircleRed = () => (
  <svg
    className="redCircle"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    viewBox="0 0 132.77 132.77"
  >
    <style>
      {
        ".circleRed__st2{fill:none;stroke:#a8092e;stroke-width:1.2011;stroke-miterlimit:10}"
      }
    </style>
    <g opacity={0.58} className="itemTo bounce3">
      <circle
        cx={66.38}
        cy={66.38}
        r={66.13}
        fill="none"
        stroke="#a8092e"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <path
        className="circleRed__st2 drawIn3"
        style={{ animationDelay: `1s` }}
        d="M67.86 125.06c12.1-.2 24.24-4.12 34.6-12.03 25.76-19.66 30.71-56.48 11.05-82.24C95.33 6.97 62.47.95 37.26 15.72"
      />
      <path
        className="circleRed__st2 drawIn3"
        style={{ animationDelay: `1.5s` }}
        d="M67.71 117.29c10.5-.17 21.04-3.57 30.03-10.43 22.35-17.06 26.64-49 9.59-71.35-8.53-11.18-20.78-17.84-33.69-19.58"
      />
      <path
        className="circleRed__st2 drawIn3"
        style={{ animationDelay: `2s` }}
        d="M68.22 109.43c8.67-.27 17.34-3.15 24.76-8.81 16.24-12.39 21.21-34.07 13.15-51.92"
      />
    </g>
  </svg>
);

export default CircleRed;
